<div class="client-form core-screen">
  <div class="client-form__main-content">
    <form [formGroup]="form" class="client-form__form">
      <div class="client-form__photo-block">
        <div class="client-form__avatar-wrap">
          <div
            class="client-form__avatar"
            [class.client-form__avatar--has-image]="!!displayPhotoUrl()"
          >
            @if (displayPhotoUrl(); as photoSrc) {
              <img
                class="client-form__avatar-img"
                [src]="photoSrc"
                alt=""
                loading="lazy"
                decoding="async"
              />
            } @else {
              <svg
                class="client-form__avatar-placeholder"
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <circle cx="12" cy="8" r="4" stroke="white" stroke-width="2" />
                <path
                  d="M6 21c0-3.314 2.686-6 6-6s6 2.686 6 6"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            }
          </div>
          @if (photoFile()) {
            <button
              type="button"
              class="client-form__avatar-clear"
              (click)="clearPendingPhoto()"
              [attr.aria-label]="'admin.users.create.photoClearPending' | translate"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M18 6L6 18M6 6l12 12"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </button>
          }
          <button
            type="button"
            class="client-form__avatar-camera"
            (click)="onPickPhoto()"
            [disabled]="isSubmitting()"
            [attr.aria-label]="'admin.users.create.photoHint' | translate"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2v11z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <circle cx="12" cy="13" r="4" stroke="currentColor" stroke-width="2" />
            </svg>
          </button>
        </div>
        <p class="client-form__photo-hint">
          {{ 'admin.users.create.photoHint' | translate }}
        </p>
      </div>

      <lib-not-input
        type="text"
        formControlName="lastName"
        [label]="'admin.users.create.lastNameLabel' | translate"
        [required]="true"
        [placeholder]="'admin.users.create.lastNamePlaceholder' | translate"
        [error]="getFieldError('lastName') | translate"
        [height]="'56px'"
      />

      <lib-not-input
        type="text"
        formControlName="firstName"
        [label]="'admin.users.create.firstNameLabel' | translate"
        [required]="true"
        [placeholder]="'admin.users.create.firstNamePlaceholder' | translate"
        [error]="getFieldError('firstName') | translate"
        [height]="'56px'"
      />

      <lib-not-input
        type="text"
        formControlName="patronymic"
        [label]="'admin.users.create.patronymicLabel' | translate"
        [required]="true"
        [placeholder]="'admin.users.create.patronymicPlaceholder' | translate"
        [error]="getFieldError('patronymic') | translate"
        [height]="'56px'"
      />

      <lib-not-phone-input
        formControlName="phone"
        [countrySelectionEnabled]="true"
        [label]="'admin.users.create.phoneLabel' | translate"
        [required]="true"
        [placeholder]="'admin.users.create.phonePlaceholder' | translate"
        [error]="phoneControlErrorText()"
        [height]="'56px'"
        (trigger)="unfocusedPhoneInput.next(true)"
      />

      <lib-not-input
        type="email"
        formControlName="email"
        [label]="'admin.users.create.emailLabel' | translate"
        [placeholder]="'admin.users.create.emailPlaceholder' | translate"
        [error]="getFieldError('email') | translate"
        [height]="'56px'"
      />

      <lib-not-input
        type="text"
        formControlName="telegram_link"
        [label]="'admin.users.messengers.telegramLabel' | translate"
        [placeholder]="'admin.users.messengers.telegramPlaceholder' | translate"
        [height]="'56px'"
      />

      <lib-not-input
        type="text"
        formControlName="whatsapp_link"
        [label]="'admin.users.messengers.whatsappLabel' | translate"
        [placeholder]="'admin.users.messengers.whatsappPlaceholder' | translate"
        [height]="'56px'"
      />

      <lib-not-input
        type="text"
        formControlName="viber_link"
        [label]="'admin.users.messengers.viberLabel' | translate"
        [placeholder]="'admin.users.messengers.viberPlaceholder' | translate"
        [height]="'56px'"
      />
    </form>
  </div>

  <div class="client-form__actions">
    <lib-cabinet-button
      type="submit"
      variant="primary"
      size="lg"
      [fullWidth]="true"
      [disabled]="isSubmitDisabled()"
      [isLoading]="isSubmitting()"
      [text]="'common.actions.create' | translate"
      [action]="{ type: 'action' }"
      (actionEvent)="onSubmit()"
    />
  </div>
</div>
